// stream.js — FootballGirl TV Streaming UI

const LEAGUES = [
    { id: 'highlights', abbr: 'HL',  name: "Highlights", color: '#e5001c', logo: '/images/logo2.png' },
    { id: 'uwcl',   abbr: 'UWCL',    name: "UEFA Women's Champions League", color: '#1a237e', logo: '/images/womenschampionsleague.png' },
    { id: 'nwsl',   abbr: 'NWSL',    name: "National Women's Soccer League", color: '#b71c1c', logo: '/images/league_nwsl.png' },
    { id: 'wsl',    abbr: 'WSL',     name: "Women's Super League", color: '#4a148c', logo: '/images/league_wsl.png' },
    { id: 'd1f',    abbr: 'D1F',     name: 'D1 Arkema', color: '#003087', logo: '/images/league_apl.png' },
    { id: 'ligaf',  abbr: 'LigaF',   name: 'Liga F', color: '#c62828', logo: '/images/league_ligaf.png' },
    { id: 'fbl',    abbr: 'FBL',     name: 'Frauen-Bundesliga', color: '#1b5e20', logo: '/images/league_dfb.png' },
    { id: 'saf',    abbr: 'SAF',     name: 'Serie A Femminile', color: '#0d47a1', logo: '/images/league_seriea.png' },
    { id: 'dam',    abbr: 'DAM',     name: 'Damallsvenskan', color: '#ffd600', logo: '/images/league_obos.png' },
    { id: 'fifawc', abbr: 'FIFAWC',  name: "Women's World Cup", color: '#e65100', logo: '/images/womensworldcup.png' },
    { id: 'afc',    abbr: 'AFC',     name: "AFC Asian Cup", color: '#d32f2f', logo: '/images/afc.png' },
    { id: 'a-lea',  abbr: 'A-LEA',   name: 'A-League Women', color: '#880e4f', logo: '/images/league_a.png' },
    { id: 'usl',    abbr: 'USL',     name: "USL Super League", color: '#bf360c', logo: '/images/league_usl.png' },
    { id: 'brasil', abbr: 'BRA',     name: 'Brasileira Campeonato', color: '#c62828', logo: '/images/league_bra.png' },
    { id: 'we',     abbr: 'WE',      name: 'WE league', color: '#6a1b9a', logo: '/images/league_we.png' },
    { id: 'wafcon', abbr: 'WAFCON',  name: 'Africa Women Cup of Nations', color: '#2e7d32', logo: '/images/wafcon.png' },
    { id: 'ligabpi', abbr: 'BPI',    name: 'Liga BPI', color: '#0277bd', logo: '/images/league_bpi.png' },
    { id: 'worldsevens', abbr: 'W7', name: "World Sevens Football", color: '#000', logo: '/images/worldsevens.png' },
    { id: 'conme',  abbr: 'CONME',   name: 'Copa América Femenina', color: '#1565c0', logo: '/images/logo2.png' },
    { id: 'euro-w', abbr: 'EURO-W',  name: "UEFA Women's Euro", color: '#0277bd', logo: '/images/logo2.png' },
    { id: 'wk',     abbr: 'WK',      name: "WK League", color: '#e91e8c', logo: '/images/league_wk.png' },
  ];
  
  export class Stream {
    constructor(containerId) {
      this.containerId = containerId;
      this.apiKey = import.meta.env.VITE_YOUTUBE_API_KEY || '';
      this.sources = {};
      this.playlist = [];        // flat list: official[0..19] + broadcaster[0..19]
      this.officialCount = 0;    // how many came from official playlist
      this.activeLeague = LEAGUES[0].id;
      this.isPlaying = false;
      this.currentVideo = null;
    }
  
    // ─── Lifecycle ───────────────────────────────────────────────────────────────
  
    async init() {
      this.container = document.getElementById(this.containerId);
      if (!this.container) return;
  
      this.injectStyles();
      this._renderShell();   // draw chrome immediately; no full re-render on video load
      this._bindEvents();
  
      try {
        const response = await fetch('/js/data/leagueSources.json');
        this.sources = await response.json();
        this.renderLeagueRows(this.activeLeague);
      } catch (e) {
        console.error('Failed to load leagueSources.json', e);
      }
    }
  
    destroy() {
      const styleEl = document.getElementById('tv-channel-styles');
      if (styleEl) styleEl.remove();
      this.container.innerHTML = '';
    }
  
    // ─── Shell render (once) ────────────────────────────────────────────────────
    // We only rebuild the player iframe area on video change, never the whole page.
  
    _renderShell() {
      this.container.innerHTML = `
        <div class="tvc-root">
          <div class="tvc-player-wrap">
            <div class="tvc-player" id="tvc-player">
  
              <!-- iframe lives here; replaced on video select -->
              <div id="tvc-iframe-slot"></div>
  
              <!-- Prev / Next overlay — visible on player hover -->
              <div class="tvc-hover-controls" id="tvc-hover-controls">
                <button class="tvc-hover-btn" id="tvc-prev-btn" title="Previous video">⏮</button>
                <button class="tvc-hover-btn tvc-hover-btn-main" id="tvc-mid-play-btn" title="Play/Pause">⏸</button>
                <button class="tvc-hover-btn" id="tvc-next-btn" title="Next video">⏭</button>
              </div>
  
              <!-- Bottom gradient controls bar -->
              <div class="tvc-controls" id="tvc-controls">
                <div class="tvc-controls-row">
                  <div class="tvc-controls-left"></div>
                  <div class="tvc-controls-right">
                    <button class="tvc-ctrl-btn" aria-label="Settings">⚙</button>
                    <button class="tvc-ctrl-btn" id="tvc-fullscreen-btn" aria-label="Fullscreen">⛶</button>
                  </div>
                </div>
              </div>
  
              <button class="tvc-add-btn" id="tvc-add-btn" aria-label="Add to list">+</button>
            </div>
          </div>
  
          ${this._leagueScrollerTemplate()}
  
          <div id="tvc-dynamic-rows"></div>
        </div>
      `;
    }
  
    // ─── Player: swap only the iframe slot ──────────────────────────────────────
  
    _updatePlayer() {
      const slot = this.container.querySelector('#tvc-iframe-slot');
      const player = this.container.querySelector('#tvc-player');
      if (!slot) return;
  
      if (this.currentVideo?.streamUrl) {
        // Remove poster background once a video is active
        player.style.backgroundImage = '';
        this.isPlaying = true;
        this.container.querySelector('#tvc-mid-play-btn').textContent = '⏸';
        slot.innerHTML = `
          <iframe
            id="tvc-actual-player"
            src="${this.currentVideo.streamUrl}"
            style="position:absolute;inset:0;width:100%;height:100%;border:none;z-index:5;"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
          <div id="tvc-yt-blocker" style="position:absolute;bottom:0;left:0;width:180px;height:42px;z-index:10;cursor:default;" aria-hidden="true"></div>`;
      } else {
        const thumb = this.currentVideo?.thumb || '';
        player.style.backgroundImage = thumb ? `url(${thumb})` : '';
        player.style.backgroundSize = 'cover';
        player.style.backgroundPosition = 'center';
        slot.innerHTML = '';
      }
  
      // Highlight active card in the list
      this._highlightActive();
    }
  
    // ─── League Scroller Template ────────────────────────────────────────────────
  
    _leagueScrollerTemplate() {
      const logos = LEAGUES.map(l => `
        <button class="tvc-league-pill ${l.id === this.activeLeague ? 'tvc-league-active' : ''}"
          data-league="${l.id}" title="${l.name}" aria-label="${l.name}">
          <img src="${l.logo}" alt="${l.abbr}" class="tvc-league-logo">
        </button>
      `).join('');
      return `
        <div class="tvc-league-section">
          <div class="tvc-league-scroll" id="tvc-league-scroll">${logos}</div>
        </div>`;
    }
  
    // ─── API ─────────────────────────────────────────────────────────────────────
  
    async fetchPlaylistVideos(playlistId, maxResults = 20) {
      if (!playlistId || !this.apiKey) return [];
      const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${playlistId}&key=${this.apiKey}`;
      try {
        const res = await fetch(url);
        const data = await res.json();
        return (data.items || []).map(item => ({
          id: item.snippet.resourceId.videoId,
          title: item.snippet.title,
          subtitle: item.snippet.channelTitle,
          thumb: item.snippet.thumbnails?.medium?.url || item.snippet.thumbnails?.default?.url || '',
          streamUrl: `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}?autoplay=1&modestbranding=1&enablejsapi=1`,
        }));
      } catch (e) {
        console.error('YouTube Fetch Error', e);
        return [];
      }
    }
  
    async renderLeagueRows(leagueId) {
      const rowContainer = this.container.querySelector('#tvc-dynamic-rows');
      if (!rowContainer) return;
  
      const source = this.sources[leagueId];
      if (!source) {
        rowContainer.innerHTML = `<p style="padding:40px;color:#888;text-align:center;">No video sources configured for this league yet.</p>`;
        return;
      }
  
      rowContainer.innerHTML = `<div class="tvc-loader">Syncing Feed…</div>`;
  
      const [official, broadcaster] = await Promise.all([
        this.fetchPlaylistVideos(source.row1, 20),
        this.fetchPlaylistVideos(source.row2, 20),
      ]);
  
      this.officialCount = official.length;
      this.playlist = [...official, ...broadcaster];
      this._drawRows();
    }
  
    // ─── Draw rows (no full re-render) ──────────────────────────────────────────
  
    _drawRows() {
      const rowContainer = this.container.querySelector('#tvc-dynamic-rows');
      if (!rowContainer) return;
  
      if (this.playlist.length === 0) {
        rowContainer.innerHTML = `<p style="padding:40px;color:#888;text-align:center;">No videos found.</p>`;
        return;
      }
  
      const official    = this.playlist.slice(0, this.officialCount);
      const broadcaster = this.playlist.slice(this.officialCount);
  
      const generateRow = (title, items) => {
        if (!items.length) return '';
        return `
          <div class="tvc-row-section">
            <div class="tvc-more-header">${title}</div>
            <div class="tvc-h-scroll" data-draggable="true">
              ${items.map((v, i) => `
                <div class="tvc-exp-card ${this.currentVideo?.id === v.id ? 'tvc-card-active' : ''}"
                     data-video-id="${v.id}"
                     role="button" tabindex="0"
                     aria-label="${v.title.replace(/"/g, '&quot;')}">
                  <div class="tvc-exp-thumb" style="background-image:url(${v.thumb})">
                    <div class="tvc-exp-hover-play">▶</div>
                  </div>
                  <div class="tvc-exp-meta">
                    <span class="tvc-exp-title">${v.title}</span>
                    <span class="tvc-exp-sub">${v.subtitle}</span>
                  </div>
                </div>
              `).join('')}
            </div>
          </div>`;
      };
  
      rowContainer.innerHTML =
        generateRow('Official Highlights', official) +
        generateRow('Match Coverage', broadcaster);
  
      // Event delegation: one listener per scroll row — no per-card binding
      rowContainer.querySelectorAll('.tvc-h-scroll').forEach(row => {
        this._makeDraggable(row);
        row.addEventListener('click', (e) => {
          const card = e.target.closest('.tvc-exp-card');
          if (!card) return;
          const video = this.playlist.find(v => v.id === card.dataset.videoId);
          if (video) this._loadVideo(video);
        });
        row.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            const card = e.target.closest('.tvc-exp-card');
            if (card) { e.preventDefault(); card.click(); }
          }
        });
      });
    }
  
    _highlightActive() {
      this.container.querySelectorAll('.tvc-exp-card').forEach(card => {
        card.classList.toggle('tvc-card-active', card.dataset.videoId === this.currentVideo?.id);
      });
    }
  
    // ─── Events ─────────────────────────────────────────────────────────────────
  
    _bindEvents() {
      // Fullscreen
      this.container.querySelector('#tvc-fullscreen-btn')?.addEventListener('click', () => {
        const player = this.container.querySelector('#tvc-player');
        if (!player || !document.fullscreenEnabled) return;
        document.fullscreenElement ? document.exitFullscreen() : player.requestFullscreen();
      });
  
      // Prev / Next / Play
      this.container.querySelector('#tvc-prev-btn')?.addEventListener('click', (e) => { e.stopPropagation(); this._playPrev(); });
      this.container.querySelector('#tvc-next-btn')?.addEventListener('click', (e) => { e.stopPropagation(); this._playNext(); });
      this.container.querySelector('#tvc-mid-play-btn')?.addEventListener('click', (e) => { e.stopPropagation(); this._togglePlayPause(); });
  
      // League scroller
      const leagueScroll = this.container.querySelector('#tvc-league-scroll');
      if (leagueScroll) {
        this._makeDraggable(leagueScroll);
        leagueScroll.addEventListener('click', (e) => {
          const pill = e.target.closest('.tvc-league-pill');
          if (!pill) return;
          leagueScroll.querySelectorAll('.tvc-league-pill').forEach(p => p.classList.remove('tvc-league-active'));
          pill.classList.add('tvc-league-active');
          this.activeLeague = pill.dataset.league;
          this.currentVideo = null;
          this.playlist = [];
          this._updatePlayer();
          this.renderLeagueRows(this.activeLeague);
          this.container.dispatchEvent(new CustomEvent('leagueSelected', { bubbles: true, detail: { league: this.activeLeague } }));
        });
      }
    }
  
    // ─── Navigation ─────────────────────────────────────────────────────────────
  
    _playNext() {
      const idx = this.playlist.findIndex(v => v.id === this.currentVideo?.id);
      if (idx !== -1 && idx < this.playlist.length - 1) this._loadVideo(this.playlist[idx + 1]);
    }
  
    _playPrev() {
      const idx = this.playlist.findIndex(v => v.id === this.currentVideo?.id);
      if (idx > 0) this._loadVideo(this.playlist[idx - 1]);
    }
  
    _togglePlayPause() {
      const iframe = this.container.querySelector('#tvc-actual-player');
      if (!iframe) return;

      this.isPlaying = !this.isPlaying;
      const btn = this.container.querySelector('#tvc-mid-play-btn');
      if (btn) btn.textContent = this.isPlaying ? '⏸' : '▶';

      const command = this.isPlaying ? 'playVideo' : 'pauseVideo';
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: command,
        args: []
      }), '*');
    }

    _loadVideo(item) {
      this.currentVideo = item;
      this._updatePlayer();   // swap only the iframe — rows stay intact
      this.container.dispatchEvent(new CustomEvent('videoSelected', {
        bubbles: true,
        detail: { id: item.id, title: item.title, url: item.streamUrl || '' }
      }));
  
      // Scroll player into view smoothly
      this.container.querySelector('#tvc-player')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  
    // ─── Draggable scroll ────────────────────────────────────────────────────────
  
    _makeDraggable(el) {
      let isDown = false, startX = 0, scrollLeft = 0, moved = false;
  
      el.addEventListener('pointerdown', (e) => {
        // Never intercept clicks on cards or buttons — let them bubble naturally
        if (e.target.closest('button, .tvc-exp-card')) return;
        isDown = true; moved = false;
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        el.setPointerCapture(e.pointerId);
        el.style.cursor = 'grabbing';
      });
  
      el.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const walk = (e.pageX - el.offsetLeft) - startX;
        if (Math.abs(walk) > 5) moved = true;
        el.scrollLeft = scrollLeft - walk;
      });
  
      ['pointerup', 'pointercancel'].forEach(ev => el.addEventListener(ev, () => {
        isDown = false;
        el.style.cursor = '';
        // If the user dragged, block the next click (once, capture phase)
        if (moved) {
          el.addEventListener('click', e => e.stopImmediatePropagation(),
            { capture: true, once: true });
        }
      }));
    }
  
    // ─── Styles ─────────────────────────────────────────────────────────────────
  
    injectStyles() {
      if (document.getElementById('tv-channel-styles')) return;
      const style = document.createElement('style');
      style.id = 'tv-channel-styles';
      style.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;700&family=DM+Sans:wght@400;500&display=swap');
  
        .tvc-root {
          background: #0f0f13;
          color: #fff;
          font-family: 'DM Sans', sans-serif;
          width: 100%;
          min-height: 100vh;
          box-sizing: border-box;
          padding-bottom: 32px;
          user-select: none;
        }
  
        /* ── Player ── */
        .tvc-player-wrap {
          display: flex;
          justify-content: center;
          padding: 16px 16px 0;
        }
  
        .tvc-player {
          position: relative;
          width: 100%;
          max-width: 780px;
          aspect-ratio: 16 / 9;
          background: #111;
          border-radius: 8px;
          overflow: hidden;
        }
  
        /* ── Prev / Next overlay (appears on player hover) ── */
        .tvc-hover-controls {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
          opacity: 0;
          transition: opacity 0.25s ease;
          z-index: 20;           /* above iframe */
          pointer-events: none;  /* pass-through by default */
        }
        /* Show on player hover — use the wrapper so the invisible area triggers it */
        .tvc-player-wrap:hover .tvc-hover-controls {
          opacity: 1;
          pointer-events: auto;
        }
  
        .tvc-hover-btn {
          background: rgba(0,0,0,0.55);
          border: 1.5px solid rgba(255,255,255,0.4);
          border-radius: 50%;
          width: 48px;
          height: 48px;
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s, transform 0.2s;
          flex-shrink: 0;
        }
        .tvc-hover-btn:hover { background: rgba(229,0,28,0.75); transform: scale(1.1); }
  
        /* ── Bottom controls bar ── */
        .tvc-controls {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          z-index: 20;
          background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%);
          padding: 28px 14px 10px;
          pointer-events: none;  /* let clicks through to iframe */
        }
        .tvc-controls-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          pointer-events: auto;
        }
        .tvc-controls-left, .tvc-controls-right {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .tvc-ctrl-btn {
          background: none;
          border: none;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          padding: 4px;
          opacity: 0.85;
          transition: opacity 0.15s;
        }
        .tvc-ctrl-btn:hover { opacity: 1; }
  
        /* ── Add btn ── */
        .tvc-add-btn {
          position: absolute;
          top: 12px; right: 12px;
          z-index: 25;
          width: 34px; height: 34px;
          border-radius: 50%;
          border: 1.5px solid rgba(255,255,255,0.6);
          background: rgba(0,0,0,0.4);
          color: #fff;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.15s;
          padding: 0;
        }
        .tvc-add-btn:hover { background: rgba(255,255,255,0.15); }
  
        /* ── Loader ── */
        .tvc-loader {
          padding: 40px;
          text-align: center;
          color: #888;
          font-size: 14px;
          letter-spacing: 0.05em;
        }
  
        /* ── League Scroller ── */
        .tvc-league-section { padding: 12px 0 0; }
        .tvc-league-scroll {
          display: flex;
          align-items: center;
          gap: 12px;
          overflow-x: scroll;
          scroll-behavior: smooth;
          padding: 8px 16px;
          scrollbar-width: none;
          cursor: grab;
        }
        .tvc-league-scroll::-webkit-scrollbar { display: none; }
        .tvc-league-scroll:active { cursor: grabbing; }
  
        .tvc-league-pill {
          flex: 0 0 auto;
          width: 52px; height: 52px;
          background: #fff;
          border: 2px solid transparent;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          padding: 8px;
          overflow: hidden;
        }
        .tvc-league-pill:hover { transform: scale(1.05); }
        .tvc-league-pill.tvc-league-active {
          border-color: #e5001c;
          box-shadow: 0 0 12px rgba(229,0,28,0.35);
        }
        .tvc-league-logo { width: 100%; height: 100%; object-fit: contain; pointer-events: none; }
  
        /* ── Video Rows ── */
        .tvc-row-section { padding: 16px 0 0; }
        .tvc-more-header {
          font-family: 'DM Sans', sans-serif;
          font-size: 18px;
          font-weight: 500;
          color: #fff;
          padding: 0 16px 8px;
        }
  
        .tvc-h-scroll {
          display: flex;
          gap: 12px;
          overflow-x: scroll;
          scroll-behavior: smooth;
          padding: 4px 16px 12px;
          scrollbar-width: none;
          cursor: grab;
        }
        .tvc-h-scroll::-webkit-scrollbar { display: none; }
        .tvc-h-scroll:active { cursor: grabbing; }
  
        /* ── Video Card ── */
        .tvc-exp-card {
          flex: 0 0 auto;
          width: 200px;
          cursor: pointer;
          outline: none;
        }
        .tvc-exp-card.tvc-card-active .tvc-exp-thumb {
          outline: 2.5px solid #e5001c;
          outline-offset: -2px;
        }
  
        .tvc-exp-thumb {
          position: relative;
          width: 100%;
          height: 125px;
          background: #1a1a24;
          border-radius: 6px;
          overflow: hidden;
          background-size: cover;
          background-position: center;
          transition: transform 0.18s;
        }
        .tvc-exp-card:hover .tvc-exp-thumb { transform: scale(1.02); }
        .tvc-exp-card:focus-visible .tvc-exp-thumb { outline: 2px solid #e5001c; }
  
        .tvc-exp-hover-play {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #fff;
          opacity: 0;
          transition: opacity 0.18s, background 0.18s;
          border-radius: 6px;
        }
        .tvc-exp-card:hover .tvc-exp-hover-play { opacity: 1; background: rgba(0,0,0,0.4); }
  
        .tvc-exp-meta { padding: 6px 2px 0; }
        .tvc-exp-title {
          display: block;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .tvc-exp-sub { display: block; font-size: 11px; color: #888; white-space: nowrap; margin-top: 2px; }
  
        /* ── Mobile ── */
        @media (max-width: 600px) {
          .tvc-player-wrap { padding: 0; }
          .tvc-player { border-radius: 0; max-width: 100%; }
          .tvc-exp-card { width: 160px; }
          .tvc-exp-thumb { height: 100px; }
          .tvc-hover-btn { width: 40px; height: 40px; font-size: 16px; }
        }
      `;
      document.head.appendChild(style);
    }
  }
  
  // ─── Auto-init ───────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('tv-channel-root');
    if (root) {
      const tv = new Stream('tv-channel-root');
      tv.init();
      root.addEventListener('leagueSelected', e => console.log('[Stream] League:', e.detail));
      root.addEventListener('videoSelected',  e => console.log('[Stream] Video:', e.detail));
    }
  });